<template>
  <div class="k-btn-body" style="position: relative;" @mouseenter="btnEnter" @mouseleave="btnLeave">
    <!-- <k-preview :slides="[slides]">
      <template slot-scope="scope">
        <slot name="img" v-bind:item="scope.item">
          <img :id="scope.item.id" :src="scope.item.src" />
        </slot>
      </template>
    </k-preview> -->
    <div style="height: 100%;">
      <div class="my-gallery" data-pswp-uid="2" style="height: 100%;">
        <figure style="height: 100%;">
          <a>
            <slot name="img" v-bind:item="slides">
              <img :id="slides.id" :src="slides.src" />
            </slot>
          </a>
          <figcaption style="display: none;"></figcaption>
        </figure>
      </div>
    </div>
    <div v-if="isShow && isSwitch==true" class="btn-img">
      <slot name="btn" v-bind:item="slides">
        <div @click="onClick">查看大图</div>
        <div @click="onClick">重新上传</div>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'k-btn-img',
  props: {
    slides: {},
    src: String,
    isSwitch: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  mounted() {
  },
  methods: {
    btnEnter() {
      this.isShow = true;
    },
    btnLeave() {
      this.isShow = false;
    },
    onClick() {
      // $('#' + this.slides.Id).click();
      console.log(this.src);
    },
    onDow() {
      $('#' + this.slides.Id).click();
    }
  }
}
</script>
<style lang="scss" scoped>
.k-btn-body {
  width: 136px;
  height: 48px;
  .item-sc-img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border: 1px dashed #dedede;
    cursor: pointer;
  }
  .btn-img {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: 5px;
    position: absolute;
    top: 0;
    div {
      flex: 1;
      font-size: 12px;
      justify-content: center;
      display: flex;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/btn-img/src/btnImg.vue